import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, checkAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState('Autenticando...');

  const processSession = useCallback(async () => {
    try {
      // Parse session_id from URL hash
      const hash = location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        setError('Session ID não encontrado no callback');
        toast.error('Session ID não encontrado');
        setTimeout(() => navigate('/login'), 2000);
        return;
      }

      setStatus('Validando sessão...');

      // Exchange session_id for user data via backend
      const response = await axios.post(
        `${API_URL}/auth/session`,
        { session_id: sessionId },
        { withCredentials: true }
      );

      setStatus('Login bem sucedido!');

      const userData = response.data;
      
      // Store user in auth context
      login(userData, null);
      
      // Refresh auth state to get full user data
      await checkAuth();
      
      toast.success('Login realizado com sucesso!');
      
      // Clear the hash and redirect to dashboard
      navigate('/dashboard', { replace: true });
      
    } catch (err) {
      const errorMessage = err.response?.data?.detail || 'Erro na autenticação com Google';
      setError(errorMessage);
      toast.error(errorMessage);
      
      // Redirect to login after showing error
      setTimeout(() => navigate('/login'), 3000);
    }
  }, [location.hash, navigate, login, checkAuth]);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    processSession();
  }, [processSession]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center max-w-md mx-auto p-6">
        {error ? (
          <>
            <div className="w-16 h-16 rounded-full bg-risk-high/20 flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl text-risk-high">!</span>
            </div>
            <h2 className="text-xl font-bold text-white mb-2">Erro na Autenticação</h2>
            <p className="text-white/60 mb-4">{error}</p>
            <p className="text-white/40 text-sm">A redirecionar para login...</p>
          </>
        ) : (
          <>
            <div className="inline-block w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mb-4" />
            <p className="text-primary font-mono text-lg">{status}</p>
          </>
        )}
      </div>
    </div>
  );
}
